import { useCallback } from "react";
import { useCurrentStepValidation } from "./useCurrentStepValidation";
export const useMultiStepValidation = (aggregatedValidation) => {
  const {
    checkCurrentStepValidation,
    getCurrentStepErrors,
    isCurrentStepSearching,
  } = useCurrentStepValidation(aggregatedValidation);

  const checkMultipleStepsValidation = useCallback(
    (steps) => {
      if (!Array.isArray(steps) || steps.length === 0) {
        return false;
      }

      return steps.some((step) => checkCurrentStepValidation(step));
    },
    [checkCurrentStepValidation]
  );

  const getValidationSummary = useCallback(
    (steps) => {
      if (!Array.isArray(steps)) {
        return { hasErrors: false, errorSteps: [], totalErrors: 0 };
      }

      const errorSteps = steps.filter((step) =>
        checkCurrentStepValidation(step)
      );
      const totalErrors = steps.reduce((total, step) => {
        return total + getCurrentStepErrors(step).length;
      }, 0);

      return {
        hasErrors: errorSteps.length > 0,
        errorSteps,
        totalErrors,
        validSteps: steps.filter((step) => !checkCurrentStepValidation(step)),
      };
    },
    [checkCurrentStepValidation, getCurrentStepErrors]
  );

  return {
    checkCurrentStepValidation,
    getCurrentStepErrors,
    isCurrentStepSearching,
    checkMultipleStepsValidation,
    getValidationSummary,
  };
};
